import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("GlobalConfigPage", {
  title: "GlobalConfigPage",
  hideInSelectionDialogs: true,
  properties: ["body"],
});
